export const NEW_CHAT_TITLE = 'Untitled';
export const NEW_CHAT_TITLE_OLD = 'New Chat';

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

// Error codes for structured error handling
// These are used by AppError on the backend and checked by the frontend
export const ErrorCode = {
	INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];

import type { IconPackId, DesignSystemFont } from './interfaces';

export const DEFAULT_DS_TITLE = 'Untitled Design System';

// Default icon pack for new design systems (Phosphor chosen because it's believed to be popular with designers)
export const DEFAULT_ICON_PACK: IconPackId = 'phosphor';

// Default font for new design systems (Inter chosen for its popularity and readability)
export const DEFAULT_DS_FONT: DesignSystemFont = {
	fontFamily: 'Inter',
	source: 'google',
	fontWeight: ['400', '500', '600', '700'],
	fallback: 'sans-serif',
};

// Icon pack configuration
// - type: 'css' = just needs <link> tag, 'js' = needs <script> tag
// - initScript: optional JS to run after script loads (for packs like Lucide that need initialization)
// - Using @latest for all packs: icon libraries are stable and rarely have breaking changes
export const ICON_PACKS: Record<
	IconPackId,
	{
		name: string;
		cdnLink: string;
		usage: string;
		searchUrl?: string;
		type: 'css' | 'js';
		initScript?: string;
	}
> = {
	'material-symbols': {
		name: 'Material Symbols',
		// Google Fonts doesn't use versioning - always serves latest
		cdnLink:
			'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200',
		usage: '<span class="material-symbols-outlined">home</span>',
		searchUrl: 'https://fonts.google.com/icons',
		type: 'css',
	},
	phosphor: {
		name: 'Phosphor',
		cdnLink: 'https://unpkg.com/@phosphor-icons/web/src/regular/style.css',
		usage: '<i class="ph ph-house"></i>',
		searchUrl: 'https://phosphoricons.com',
		type: 'css',
	},
	lucide: {
		name: 'Lucide',
		cdnLink: 'https://unpkg.com/lucide@latest',
		usage: '<i data-lucide="home"></i>',
		searchUrl: 'https://lucide.dev/icons',
		type: 'js',
		initScript: 'lucide.createIcons();',
	},
	'font-awesome': {
		name: 'Font Awesome',
		cdnLink: 'https://unpkg.com/@fortawesome/fontawesome-free/css/all.min.css',
		usage: '<i class="fas fa-camera"></i>',
		searchUrl: 'https://fontawesome.com/icons',
		type: 'css',
	},
};
